import { Box, Typography } from '@mui/material';
import { DataGrid, gridClasses, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { dateFormatter } from '../../../../../../utils/timeFormat';
import { RootState } from '../../../../../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../store/store';
import { clearSelections, getADTAlerts, getTopThreeMatches, setRowSelectionModel, setUnmatchedId } from '../../../../../../store/hie.slice';
import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { isDefaultDate } from '../../../../../../utils/common';
// import { HIEAlertTypeEnum } from '../../../../../../Enum/HIEAlertTypeEnum';
import { useEffect, useState } from 'react';
import { toDate } from '../../../../../../utils/dateHelpers';
import { GridRowSelectionModel } from '@mui/x-data-grid';

const ADTAlerts = () => {
    const dispatch = useAppDispatch();

    const { adtAlerts, unmatchedId, showArchivedAlerts } = useSelector((state: RootState) => state.hie);
    const [alertsRowSelectionModel, setAlertsRowSelectionModel] = useState<GridRowSelectionModel>({
        type: 'include', // or 'exclude'
        ids: new Set([]), // Your initial row IDs
    });
    const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0 });

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            minWidth: 160,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            minWidth: 160,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            minWidth: 160,
            flex: 1,
        },
        {
            field: 'CHPDownloadDate',
            headerName: 'Download Date',
            minWidth: 160,
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.CHPDownloadDate) ? '-' : dateFormatter(new Date(row.CHPDownloadDate))}`,
        },
        {
            field: 'SendingFacility',
            headerName: 'Sending Facility',
            minWidth: 270,
            flex: 1.5,
        },
        {
            field: 'VisitType',
            headerName: 'Alert Type',
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'VisitStatus',
            headerName: 'Visit Status',
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'AdmitDate',
            headerName: 'Admission Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.AdmitDate);
                return `${isDefaultDate(row.AdmitDate) ? '-' : isValid(d) ? formatInTimeZone(d, 'UTC', 'MM/dd/yyyy') : '-'}`;
            },
        },
        {
            field: 'AdmitTime',
            headerName: 'Admission Time',
            minWidth: 160,
            valueGetter: (value, row) => `${new Date(row.AdmitTime).toLocaleTimeString()}`,
        },
        {
            field: 'DischargeDate',
            headerName: 'Discharge Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.DischargeDate);
                return `${isDefaultDate(row.DischargeDate) ? '-' : isValid(d) ? formatInTimeZone(d, 'UTC', 'MM/dd/yyyy') : '-'}`;
            },
        },
        {
            field: 'DischargeTime',
            headerName: 'Discharge Time',
            minWidth: 160,
            valueGetter: (value, row) => {
                return row.DischargeTime ? new Date(row.DischargeTime).toLocaleTimeString() : '-';
            },
        },
        {
            field: 'AdmitReason',
            headerName: 'Admission Reason',
            minWidth: 260,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Box>
                        <Typography>{params.row.AdmitReason}</Typography>
                    </Box>
                );
            },
        },
    ];

    useEffect(() => {
        dispatch(getADTAlerts());
    }, [dispatch]);

    return (
        <>
            <DataGrid
                onRowClick={(params: any) => {
                    const { DOB, Id, LastName, FirstName } = params.row;
                    dispatch(clearSelections());
                    dispatch(setUnmatchedId(Id));
                    dispatch(getTopThreeMatches(FirstName, LastName, DOB));
                }}
                autoHeight
                rows={showArchivedAlerts ? adtAlerts : adtAlerts.filter((alert) => alert.Archived !== true)}
                columns={columns}
                checkboxSelection={unmatchedId.length > 0 ? true : false}
                disableRowSelectionExcludeModel
                onRowSelectionModelChange={(newSelectionModel) => {
                    setAlertsRowSelectionModel(newSelectionModel);
                    const rowIds = Array.from(newSelectionModel.ids) || [];
                    dispatch(setRowSelectionModel(rowIds));
                }}
                rowSelectionModel={alertsRowSelectionModel}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[5]}
                getRowId={(row) => row.Id}
                getRowHeight={() => 'auto'}
                getRowClassName={(params) => (params.row.Archived ? 'archived' : '')}
                sx={{
                    [`& .${gridClasses.cell}`]: {
                        py: 1,
                    },
                    [`& .archived`]: {
                        background: 'rgba(200,200,200,0.4)',
                        fontStyle: 'italic',
                    },
                }}
            />
        </>
    );
};

export default ADTAlerts;
